import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"
import tokenClassNames from "../token-class-names.json"

const ICON_SIZE_CLASS_SUFFIX = "icon"

const twMerge = extendTailwindMerge<"text-fit">({
  extend: {
    theme: { text: tokenClassNames.textStyles, ease: tokenClassNames.easings },
    classGroups: {
      duration: [{ duration: tokenClassNames.durations }],
      size: [{ size: [ICON_SIZE_CLASS_SUFFIX] }],
      "text-fit": [{ fit: ["wrap", "break", "truncate", "nowrap"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
